import React from 'react';
import {connect} from 'react-redux';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/game-types/single-game';

class FilterComponent extends BaseFilterComponent {
    render() {
        const tabs = this.prepareTabs();

        return <div className="tabs-chk-fixed">{tabs}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
        filters: state.usedPlayers.filters,
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
